// extracted by mini-css-extract-plugin
export default {"taxDisclaimer":"styles_taxDisclaimer__nw-ud"};